import { useEffect, useRef } from "react";
import type { ProtectSearchProviderOptions } from "./registerProtectSearchProvider.tsx";
import { useRecentlyViewed } from "./useRecentlyViewed.ts";

// One hook call per provider: safe only because `providers` is a snapshot that never changes length while mounted.
export function useRecordRecentlyViewed(providers: ProtectSearchProviderOptions[]) {
    const { record } = useRecentlyViewed();

    const visited = providers.map(provider => provider.useVisitedEntry?.());
    const entry = visited.find(candidate => candidate !== undefined);

    const alreadyRecordedKeyRef = useRef<string | null>(null);

    useEffect(() => {
        if (!entry) {
            alreadyRecordedKeyRef.current = null;

            return;
        }

        const entryKey = `${entry.providerId}:${entry.id}`;

        if (alreadyRecordedKeyRef.current === entryKey) {
            return;
        }

        alreadyRecordedKeyRef.current = entryKey;
        record(entry);
    }, [entry, record]);
}
